module.exports = __webpack_public_path__ + "img/icon_lista.6150cddc.svg";